/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAccount = /* GraphQL */ `
  query GetAccount($username: String!) {
    getAccount(username: $username) {
      username
      name
      email
      phone
      timing
      address
      logo
      selectedTemplate
      description
      advancedseo
      isPaidUser
      paidWidgets
      paymentInfo
      userType
      nextBillingAt
      plan
      billingCycle
      billingCurrency
      razorpaySubscriptionId
      razorpayCustomerId
      usagePeriodEndAt
      usageFeedbackViews
      usageAiReviews
      usageExtensionResponses
      instagram
      x
      youtube
      facebook
      linkedin
      tiktok
      pintrest
      whatsapp
      reddit
      buymeacoffe
      googlemap
      calendly
      action
      widgets
      services
      gallery
      qna
      offer
      likesCount
      isDraft
      lastUpdatedField
      themeColor
      businessReviewInfo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $username: String
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccounts(
      username: $username
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        username
        name
        email
        phone
        timing
        address
        logo
        selectedTemplate
        description
        advancedseo
        isPaidUser
        paidWidgets
        paymentInfo
        userType
        nextBillingAt
        plan
        billingCycle
        billingCurrency
        razorpaySubscriptionId
        razorpayCustomerId
        usagePeriodEndAt
        usageFeedbackViews
        usageAiReviews
        usageExtensionResponses
        instagram
        x
        youtube
        facebook
        linkedin
        tiktok
        pintrest
        whatsapp
        reddit
        buymeacoffe
        googlemap
        calendly
        action
        widgets
        services
        gallery
        qna
        offer
        likesCount
        isDraft
        lastUpdatedField
        themeColor
        businessReviewInfo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
